export default "__VITE_ASSET__pulpi6qd__"